var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0 div66"},[_c('div',{staticClass:"flex-grow-1 div3"},[_vm._t("content")],2),_c('div',{staticClass:"flex-grow-0 div7"},[_vm._t("bottom")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }